// build Menu-Item
import React from 'react';
import { IRouteV2 } from '../../data';
import { UndefinedAble } from '../../data/base';
import { MenuProps } from 'antd';

type MenuItem = Required<MenuProps>['items'][number];

function buildItem(
  label: React.ReactNode,
  key: React.Key,
  icon?: React.ReactNode,
  children?: MenuItem[]
): MenuItem {
  return {
    key,
    icon,
    children,
    label,
  } as MenuItem;
}

export function buildItems(
  params: any,
  collapsed: boolean,
  routes: IRouteV2[]
): UndefinedAble<MenuItem[]> {
  return routes?.map((item) => {
    const subMenu = item.subMenu
      ? buildItems(params, collapsed, item.subMenu)
      : undefined;

    return buildItem(
      collapsed ? '' : item.name,
      replaceParams(item.path, params),
      item.icon,
      subMenu
    );
  });
}

function replaceParams(path: string, params: any): string {
  return Object.keys(params).reduce(
    (path, key) => path.replace(`:${key}`, params[key] as string),
    path
  );
}
